// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3JFju","alertIcon":"ConfirmModal_alertIcon__2e3FC"};